<template>
  <v-icon xsize="medium" color="orange">
    mdi-tag-multiple
  </v-icon>
</template>
